<template>
    <div>
        <a :href="'mailto:' + place.email">{{ place.email }}</a><br>
        <a :href="'tel:' + place.phone">{{ place.phone }}</a>
    </div>
</template>

<script>
export default {
    name: 'place-contact',
    props: ['place'],
    data() {
        return {
        }
    },
    created() {},
    computed: {},
    methods: {}
}
</script>
